import Navigation from './navigations/Navigation'
import { Provider } from 'react-redux'
import { store } from './redux/store/store'

function App() {
  return (
    <Provider store={store}>
      <Navigation />
    </Provider>
  )
}

export default App
